import React, { useEffect, useState } from "react";
import "./css/styles.css";
// import './js/script'
// const country1 = require("./images/country-1.png")
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

export default function CountryTabs(props) {
  const [selectedTab, setSelectedTab] = useState("GERMANY");
  const countryTabs = [
    {
      countryImg: require("./images/country-1.png"),
      countryName: "GERMANY",
      tabName: "germany",
      className: " cb-wrapper wow bounceInLeft",
      duration: "2s",
      delay: "0.5s",
      countryTitle: "Germany",
      countryInfo1:
        "Located in Northwestern Europe, the Germany is a charming country with a long and rich history in culture.",
      countryInfo2:
        "The country stretches over 242,495 km sq. with a population exceeding 63 million.",
      countryInfo3:
        "In addition, The UK boasts world’s best universities and institutions. The country offers the best environment to study which pushes students to break the boundaries and understand various perspectives.",
      countryInfo4:
        "Moreover, the UK offers thousands of courses to choose from which gives students a wide variety of choices.",
    },
    {
      countryImg: require("./images/country-2.png"),
      countryName: "U.S.A.",
      tabName: "usa",
      className: "cb-wrapper wow bounceInLeft",
      duration: "2s",
      delay: "1.0s",
      countryTitle: "U.S.A.",
      countryInfo1:
        "Located in Northwestern Europe, the United States is a charming country with a long and rich history in culture.",
      countryInfo2:
        "The country stretches over 242,495 km sq. with a population exceeding 63 million.",
      countryInfo3:
        "In addition, The UK boasts world’s best universities and institutions. The country offers the best environment to study which pushes students to break the boundaries and understand various perspectives.",
      countryInfo4:
        "Moreover, the UK offers thousands of courses to choose from which gives students a wide variety of choices.",
    },
    {
      countryImg: require("./images/country-3.png"),
      countryName: "UNITED KINGDOM",
      tabName: "uk",
      className: " cb-wrapper wow bounceInDown center",
      duration: "2s",
      delay: "1.5s",
      countryTitle: "United Kingdom",
      countryInfo1:
        "Located in Northwestern Europe, the United Kingdom is a charming country with a long and rich history in culture.",
      countryInfo2:
        "The country stretches over 242,495 km sq. with a population exceeding 63 million.",
      countryInfo3:
        "In addition, The UK boasts world’s best universities and institutions. The country offers the best environment to study which pushes students to break the boundaries and understand various perspectives.",
      countryInfo4:
        "Moreover, the UK offers thousands of courses to choose from which gives students a wide variety of choices.",
    },
    {
      countryImg: require("./images/country-4.png"),
      countryName: "CANADA",
      tabName: "canada",
      className: "cb-wrapper wow bounceInDown center",
      duration: "2s",
      delay: "2.0s",
      countryTitle: "Canada",
      countryInfo1:
        "Located in Northwestern Europe, the Canada is a charming country with a long and rich history in culture.",
      countryInfo2:
        "The country stretches over 242,495 km sq. with a population exceeding 63 million.",
      countryInfo3:
        "In addition, The UK boasts world’s best universities and institutions. The country offers the best environment to study which pushes students to break the boundaries and understand various perspectives.",
      countryInfo4:
        "Moreover, the UK offers thousands of courses to choose from which gives students a wide variety of choices.",
    },
    {
      countryImg: require("./images/country-5.png"),
      countryName: "U.A.E",
      tabName: "U.A.E",
      className: " cb-wrapper wow bounceInRight",
      duration: "2s",
      delay: "1.0s",
      countryTitle: "U.A.E",
      countryInfo1:
        "Located in Northwestern Europe, the U.A.E is a charming country with a long and rich history in culture.",
      countryInfo2:
        "The country stretches over 242,495 km sq. with a population exceeding 63 million.",
      countryInfo3:
        "In addition, The UK boasts world’s best universities and institutions. The country offers the best environment to study which pushes students to break the boundaries and understand various perspectives.",
      countryInfo4:
        "Moreover, the UK offers thousands of courses to choose from which gives students a wide variety of choices.",
    },
    {
      countryImg: require("./images/country-6.png"),
      countryName: "AUSTRALIA",
      tabName: "australia",
      className: " cb-wrapper wow bounceInRight",
      duration: "2s",
      delay: "0.5s",
      countryTitle: "Australia",
      countryInfo1:
        "Located in Northwestern Europe, the Australia is a charming country with a long and rich history in culture.",
      countryInfo2:
        "The country stretches over 242,495 km sq. with a population exceeding 63 million.",
      countryInfo3:
        "In addition, The UK boasts world’s best universities and institutions. The country offers the best environment to study which pushes students to break the boundaries and understand various perspectives.",
      countryInfo4:
        "Moreover, the UK offers thousands of courses to choose from which gives students a wide variety of choices.",
    },
  ];

  useEffect(() => {
    console.log(props.expectedCountry, "ecpected counrty");
    if (props.expectedCountry != null && props.expectedCountry != undefined) {
      setSelectedTab(props.expectedCountry);
      props.fetchSelectedTab(props.expectedCountry);
    }
  }, [props.expectedCountry]);

  const handleTabClick = (tabSelected) => {
    setSelectedTab(tabSelected);
    props.fetchSelectedTab(tabSelected);
  };

  const renderCountryTab = countryTabs.map((country, index) => {
    return (
      <div
        key={index}
        className={
          selectedTab === country.countryName
            ? country.className + " active"
            : country.className
        }
        data-wow-duration={country.duration}
        data-wow-delay={country.delay}
        onClick={() => handleTabClick(country.countryName)}
      >
        <div className="country-btn">
          <div className="country-image">
            <img src={country.countryImg} alt={country.countryName} />
          </div>
          <div className="country-title">{country.countryName}</div>
        </div>
      </div>
    );
  });

  return (
    <div className="country-tab">
      <div className="scrollable">{renderCountryTab}</div>
    </div>
  );
}
